import { BOOKING_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";

export interface IRefundInitate {
  booking_id: string;
}
export interface IEroorMessage {
  status: boolean;
  message: string;
}
export const useUserBookingsRefundInitiateApI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (paramsData: IRefundInitate) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: IEroorMessage = await axios
          .post(`${BOOKING_APIS?.APPOINTMENT_REFUND_INITIATE?.baseURL}` ?? "", paramsData, {
            headers: {
              Authorization: `${accessToken}`,
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true && res.data) {
              toast.success("Refund Initiated Successfully");
              return { status: true, message: res.data?.message };
              //
            } else {
              toast.error("Return Initiated Failed ");
              //
              return { status: false, message: res.data?.message };
            }
          })
          .catch((res: AxiosError) => {
            const err = res.response.data as any;
            return { status: false, message: err?.message };
          });
        return response;
      } catch (e: any) {
        toast.error("Return Initiated Failed ");
        // toast.error("Server Error: " + e.message);
        return { status: false, message: "Server Error" };
      }
    },
    [dispatch],
  );
  return { execute };
};
